import { CaretRightIcon } from "@phosphor-icons/react/dist/csr/CaretRight";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Stack } from "@volca/ui/components/ui/stack";
import { Switch } from "@volca/ui/components/ui/switch";
import { Text } from "@volca/ui/components/ui/text";
import { profitabilityRulePath } from "@/profitability/routes";
import type { ReviewRule } from "@/profitability/settings/types";

export const RuleRow = ({
  rule,
  reportId,
  runId,
  editable,
  busy,
  onToggle,
  handle,
}: {
  rule: ReviewRule;
  reportId: string;
  runId: string | null;
  editable: boolean;
  busy?: boolean;
  onToggle: (enabled: boolean) => void;
  handle?: ReactNode;
}) => {
  const evaluation = runId ? rule.track.evaluation?.[runId] : undefined;
  const count = runId ? rule.track.counts[runId] : undefined;
  const result = !runId
    ? "No periods yet"
    : evaluation === "disabled"
      ? "Off this period"
      : evaluation === "not_evaluated"
        ? "Not evaluated"
        : count !== undefined ||
            evaluation === "evaluated" ||
            evaluation === "partial"
          ? `${count ?? 0} flagged${evaluation === "partial" ? " · Partial" : ""}`
          : "Not evaluated";
  return (
    <Stack direction="row" gap={2} align="center" className="px-3">
      {handle}
      <Link
        to={profitabilityRulePath(reportId, rule.id, runId)}
        className="flex min-w-0 flex-1 items-center gap-3 rounded-md py-4 outline-offset-0 focus-visible:outline-2 focus-visible:outline-ink hover:[&_strong]:underline"
      >
        <Stack gap={1} className="min-w-0 flex-1">
          <Text
            render={<strong />}
            variant="label"
            className="[overflow-wrap:anywhere]"
          >
            {rule.label}
          </Text>
          <Text
            tone="muted"
            className="line-clamp-1 [overflow-wrap:anywhere] max-sm:hidden"
          >
            {rule.checks}
          </Text>
          <Text variant="caption" tone="muted" tabular>
            {result}
          </Text>
        </Stack>
        <CaretRightIcon
          aria-hidden
          className="size-4 shrink-0 text-subtle rtl:rotate-180"
        />
      </Link>
      <Switch
        className="pointer-coarse:after:-inset-y-3.5"
        checked={rule.enabled}
        disabled={!editable || busy}
        onCheckedChange={onToggle}
        aria-label={`Flag ${rule.label.toLowerCase()}`}
      />
    </Stack>
  );
};
